export default __webpack_public_path__ + "static/media/download-tips.9ca30c61.png";